"use strict";
import n from "./index.es119.js";
import f from "./index.es123.js";
import l from "./index.es133.js";
function d(i, o) {
  const t = this || f, a = o || t, e = l.from(a.headers);
  let r = a.data;
  return n.forEach(i, function(m) {
    r = m.call(t, r, e.normalize(), o ? o.status : void 0);
  }), e.normalize(), r;
}
export {
  d as default
};
//# sourceMappingURL=index.es331.js.map
